import { useRef } from 'react';

export const useReactQueryEnabler = () => {
    const shouldEnableQuery = useRef(false);

    const enableQuery = () => {
        shouldEnableQuery.current = true;
    };

    return {
        shouldEnableQuery: shouldEnableQuery.current,
        enableQuery,
    };
};
